module.exports = __webpack_public_path__ + "static/media/SmartNewLoading.28d1b7a6.svg";